import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getFormatedClientTime } from 'CorePackage/MainModule/common/formatDate';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';
import { apiDelete, apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

import { ImportFileStatusEnum } from '../enums/ImportFileStatusEnum';
import { IImportsResponse } from '../interfaces/IImportsResponse';
import { IImportTemplate } from '../interfaces/IImportTemplate';
import { IImportTemplateCreate } from '../interfaces/IImportTemplateCreate';
import { IImportFile } from '../interfaces/IImportFile';

export interface IFetchImportsData {
  fileType?: Array<keyof typeof UploadFileTypesEnum>;
  fileStatus?: ImportFileStatusEnum[];
  search?: string;
  currentUser?: boolean;
  filter?: Array<string>;
  order?: string;
  page?: string;
  shift?: string;
  size?: string;
}

export async function fetchImports({
  fileType,
  fileStatus,
  currentUser,
  filter,
  ...rest
}: IFetchImportsData): Promise<IImportsResponse> {
  const lawInterface = getLawInterfaceFromStorage();
  const queryParams = new URLSearchParams();

  queryParams.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));
  if (currentUser) {
    queryParams.append('currentUser', currentUser.toString());
  }
  // eslint-disable-next-line no-unused-expressions
  fileType?.forEach(fileTypeValue => queryParams.append('fileType', fileTypeValue));
  // eslint-disable-next-line no-unused-expressions
  fileStatus?.forEach(fileStatusValue => queryParams.append('fileStatus', fileStatusValue));
  // eslint-disable-next-line no-unused-expressions
  filter?.forEach(filterValue => queryParams.append('filter', filterValue));
  Object.keys(rest).forEach((key: 'search' | 'order' | 'page' | 'shift' | 'size') => {
    const value = rest[key];

    if (value) {
      queryParams.append(key, value);
    }
  });

  return apiGet<IImportsResponse>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
  );
}

interface IFetchImportCreate {
  data: IImportTemplateCreate;
}

export async function fetchImportCreate({ data }: IFetchImportCreate): Promise<IImportTemplate> {
  return apiPost<IImportTemplate>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports`,
    body: { ...data, clientTime: getFormatedClientTime() },
  });
}

interface IFetchImportDelete {
  id: number;
}

export async function fetchImportDelete({ id }: IFetchImportDelete): Promise<undefined> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports/${id}`);
}

interface IFetchImportFileUpload {
  id: number;
  file: File;
}

export async function fetchImportFileUpload({ id, file }: IFetchImportFileUpload): Promise<IImportFile> {
  const formData = new FormData();

  formData.append('file', file);

  return apiPost<IImportFile>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports/${id}/file`,
    body: formData,
  });
}

interface IFetchImportFileUrl {
  id: number;
}

export async function fetchImportFileUrl({ id }: IFetchImportFileUrl): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports/${id}/file`);
}

export async function fetchWarningsFileUrl(id: number): Promise<string> {
  return apiGet<string>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports/${id}/warnings/file`);
}

interface IFetchImportsByPlan {
  planId: number;
}

export async function fetchImportsByPlan({ planId }: IFetchImportsByPlan): Promise<IImportTemplate> {
  return apiGet<IImportTemplate>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/imports/plan/${planId}`);
}
